<template>
  <div class="banner-box">
    <p class="img-box">
      <img v-if="curConf.url" :src="curConf.url" alt="img" />
    </p>
    <p v-if="curConf.titleEn" class="title-box">
      <span class="title-en">{{curConf.titleEn}}</span>
      <span class="title-zh">{{curConf.titleZh}}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    titleEn: String,
    titleZh: String,
    url: [Function, String]
  },
  data () {
    return {
      curSelect: '/'
    }
  },
  computed: {
    curConf () {
      const {
        summary: { summaryBanner },
        culture: { cultureBanner },
        content: { contentBanner },
        product: { productBanner },
        future: { futureBanner }
      } = this.$images
      const obj = {
        '/summary': { titleEn: 'OUTLINE', titleZh: '会社概要', url: summaryBanner },
        '/culture': { titleEn: 'COMPANY', titleZh: '企業沿革', url: cultureBanner },
        '/content': { titleEn: 'SERVICE', titleZh: '事業内容', url: contentBanner },
        '/product': { titleEn: 'PRODUCT', titleZh: '取扱商品', url: productBanner },
        '/future': { titleEn: '', titleZh: '', url: futureBanner }
      }
      return obj[this.curSelect]
    }
  },
  mounted () {
    const fn = setTimeout(() => {
      this.curSelect = this.$route.path
      clearTimeout(fn)
    }, 200)
  }
}
</script>

<style lang="less" scoped>
.banner-box{
  width: 1770px;
  height: 554px;
  background: #FFFFFF;
  border-radius: 10px;
  margin-left: 75px;
  /*background-color: wheat;*/

  position: relative;

  .img-box{
    width: 100%;
    height: 100%;

    img{
      width: 100%;
      height: 100%;
    }
  }

  .title-box{
    position: absolute;
    bottom: 48px;
    left: 92px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .title-en{
      width: 195px;
      height: 37px;
      line-height: 60px;
      text-align: center;
      background: #FFFFFF;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;

      font-family: HarmonyOS_Sans_SC_Bold;
      font-weight: 400;
      font-size: 24px;
      color: #E09B4D;
      position: relative;
      z-index: 3;
    }

    .title-zh{
      width: 275px;
      height: 111px;
      line-height: 111px;
      text-align: center;
      background: #FFFFFF;
      border-top-right-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;

      font-family: 04KanjyukuGothic;
      font-weight: 400;
      font-size: 48px;
      color: #374475;
    }
  }
}
</style>
